import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  MdHome, MdLocalHospital, MdCalendarToday,
  MdPerson, MdWarning,
} from 'react-icons/md';

const NAV = [
  { path: '/',           icon: <MdHome />,           label: 'Home' },
  { path: '/hospitals',  icon: <MdLocalHospital />,   label: 'Hospitals' },
  { path: '/emergency',  icon: <MdWarning />,          label: 'SOS',  emergency: true },
  { path: '/bookings',   icon: <MdCalendarToday />,   label: 'Bookings' },
  { path: '/profile',    icon: <MdPerson />,          label: 'Profile' },
];

export default function BottomNav() {
  const navigate  = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-items">
        {NAV.map(n => (
          <button
            key={n.path}
            className={`bn-item${n.emergency ? ' bn-emergency' : ''}${pathname === n.path && !n.emergency ? ' active' : ''}`}
            onClick={() => navigate(n.path)}
          >
            {n.icon}
            {!n.emergency && <span>{n.label}</span>}
          </button>
        ))}
      </div>
    </nav>
  );
}
